export const PAGES_ACTIONS = {
    SET_PAGES: 'SET_PAGES',
    SET_PAGE: 'SET_PAGE',
    ADD_PAGE: 'ADD_PAGE',
    UPDATE_PAGE: 'UPDATE_PAGE',
    REMOVE_PAGE: 'REMOVE_PAGE',
    SET_STATUS: 'SET_PAGES_STATUS',
    SET_CURRENT_STATUS: 'SET_PAGE_CURRENT_STATUS',
    SET_ERRORS: 'SET_PAGES_ERRORS',
    CLEAR_ERRORS: 'CLEAR_PAGES_ERRORS',
    CLEAR_PAGES: 'CLEAR_PAGES',
    CLEAR_CURRENT: 'CLEAR_PAGE_CURRENT'
};
export const initialPagesState = {
    status: 'idle',
    errors: [],
    data: {},
    current: null,
    currentStatus: 'idle'
};
